import React, { useState, useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import TablaGeneral from "../../components/TablaGeneral";
import Loader from "../../components/Loader";
import configTable from "../../hook/configTable";

const UsuariosPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [datos, setDatos] = useState([])

  const eliminarItem = (id) => {
    console.log('eliminarItem', id);
    setIsLoading(true);
    try {
      fetch("/p_usuario",{
        method: "DELETE",
        headers:{
          "Content-Type": "application/json",
        },
        body: JSON.stringify({id})
      })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setDatos([])
        cargarDatos();
      });
    } catch (error) {
      console.error('Error:', error);
    }
  }

  const [datosTabla] = useState({
    titulo: "Usuarios",
    ruta: "/usuario",
    esAgregar: true,
    esEditar: true,
    esEliminar: true,
    eliminar: eliminarItem,
    configTable: configTable
  })

  const [cabecera] = useState([
    { title: "ID", key: "ID_USR" },
    { title: "NOMBRE", key: "NOMBRE_USR" },
    { title: "APELLIDO PATERNO", key: "APELLIDO_PATERNO_USR" },
    { title: "APELLIDO MATERNO", key: "APELLIDO_MATERNO_USR" },
    { title: "CORREO", key: "CORREO_USR" },
    { title: "TELEFONO", key: "TELEFONO_USR" },
    { title: "ULTIMA ACTUALIZACION", key: "FECHA_ULTIMO_CAMBIO_USR", isDate: true },
  ]);

  const cargarDatos = async () => {
    try {
      fetch("/p_usuarios",{
        method: "GET",
        headers:{
          "Content-Type": "application/json",
        }
      })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if(data.status === 1){
          setDatos(data.data);
        }
        setIsLoading(false);
      });
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    cargarDatos();
  }, []);
  return (
    <>
      <MasterLayout>
      { isLoading ? <Loader /> : <TablaGeneral datosTabla={datosTabla} datos={datos} cabecera={cabecera}/> }
      </MasterLayout>
    </>
  );
};

export default UsuariosPage;
